import React from "react";
import "../style/agentsList.css";
import AgentsListFilters from "./agentsListFilters";
import ChangeSolicitorsLawsysAgent from "./changeSolicitorsLawsysAgent";
import "../style/dots.css";
import SolicitorGroupHOC from "../containers/SolicitorGroups/solicitorGroupHOC"
import FormResponseMessage from "./formResponseMessage";
import Button from "./button";
import {LEGAL_ADVICE_TEXT, UI_LIB_TABLE_VIEW_OPTIONS, TOBA_SHORT_TEXT, TOBA_PATH} from "../helpers/variables";
import {Table, HrefLink, Icon} from 'arag-ui-lib';
import CONTENT_STRINGS from '../helpers/contentStrings';
import { goAtPrevious, goAtNext, goAtStart, goAtEnd, goAtPage, formatSolicitorTableLabel } from '../helpers/functions';

const columns = [
	{propertyName: "lawsysId", header: CONTENT_STRINGS.LAWSYS_ID, id: "orderByLawsysId", sortable: true},
	{
		propertyName: "lawsysName",
		header: `${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FIRM}`,
		formatter: (row) => formatSolicitorTableLabel({
			label: row.lawsysName ? row.lawsysName.replace(/\(ID:\s\d*\)$/g, '') : "",
			aragProvider: row.aragProvider,
		}),
		id: "orderByLawsysName",
		sortable: true
	},
	{
		propertyName: "name",
		header: CONTENT_STRINGS.NAME,
		formatter: (row) => `${row.forename} ${row.surname}`,
		id: "orderBySolicitorName",
		sortable: true
	},
	{
		propertyName: "username",
		header: CONTENT_STRINGS.USER_NAME,
		id: "orderByUserName",
		formatter: (row) => <HrefLink to={`/solicitors/edit-solicitor/${row.userId}`} label={row.username}/>,
		sortable: true
	},
	{
		propertyName: "status",
		header: CONTENT_STRINGS.STATUS,
		formatter: (row) => (
			<Icon>
				<svg xmlns="http://www.w3.org/2000/svg"
					 style={{fill: row.status ? '#94b494' : '#e0666c', width: '12px', height: '12px'}}
					 viewBox="0 0 12 12">
					<title>Asset 4</title>
					<g id="Layer_2" data-name="Layer 2">
						<g id="info"><circle className="cls-1" cx="6" cy="6" r="6"/></g>
					</g>
				</svg>
				&nbsp;{row.status ? CONTENT_STRINGS.ACTIVE : CONTENT_STRINGS.INACTIVE}
			</Icon>
		)
	},
];

const AgentsList = (props) => {
	const {onQuickSearch} = props;
	const {solicitorUsersListSettings} = props.AgentsList;

	const handlePageChange = (page) => props.SolicitorDisplaySetting('page', page);

	const selectActions = [
		{key: 'enable', label: CONTENT_STRINGS.ENABLE_USERS},
		{key: 'disable', label: CONTENT_STRINGS.DISABLE_USERS},
		{key: 'changeLawsys', label: `${CONTENT_STRINGS.CHANGE} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FIRM}`},
	];

	const onPageSizeChange = (evt) => props.SolicitorDisplaySetting('displayAmount', parseInt(evt.target.value));
	const onSelectAction = (evt) => props.UpdateCheckedSolicitors(evt.target.value);

	const prevPage = goAtPrevious(handlePageChange, solicitorUsersListSettings.page);
	const nextPage = goAtNext(handlePageChange, solicitorUsersListSettings.page, solicitorUsersListSettings.totalBoxes);
	const firstPage = goAtStart(handlePageChange);
	const lastPage = goAtEnd(handlePageChange, solicitorUsersListSettings.totalBoxes);
	const selectPage = goAtPage(handlePageChange);

	return (
		<div className="agents-list-wrapper-size form-group">
			{
				props.AgentsList.openNewSolicitorGroupModal ?
					<div className="agentsList-new-sol-group-modal">
						<div className="appFormRefSettings-modal-content">
							<div className="appFormRefSettings-close-button" onClick={()=>props.changeAgentsListSettings('openNewSolicitorGroupModal',false)}> </div>
							<SolicitorGroupHOC/>
						</div>
					</div>
					:
					null
			}
			{props.AgentsList.displayModal ?
				<ChangeSolicitorsLawsysAgent
					selectedLawsysId={props.selectedLawsysId}
					selectedSolicitorUsers={props.selectedSolicitorUsers}
					changeAgentsListSettings={props.changeAgentsListSettings}
					calculateLawsysName={props.calculateLawsysName}
					calculateLawsysAragProvider={props.calculateLawsysAragProvider}
					DisplayConfirm={props.DisplayConfirm}
					DisplayModal={props.DisplayModal}
					SelectLawsysId={props.SelectLawsysId}
					AgentsList={props.AgentsList}
					lawsysFirms = {props.lawsysFirms}
					AttachLawsys={props.AttachLawsys}
				/>
				: null
			}
			<div className="row ">
				<div className="col-sm-12 ">
					<h2 className="agents-list-title">
						{`${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.USERS} (${CONTENT_STRINGS.ATE})`}
					</h2>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-12">
					<Button clickHandler={()=>props.push('/solicitors/add-solicitor')} wrapper="btn-wrapper"
									btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
									label={`${CONTENT_STRINGS.CREATE} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.USER}`}/>
					<Button clickHandler={()=>props.push('/solicitors/solicitor-groups')} wrapper="btn-wrapper"
									btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
									label={`${CONTENT_STRINGS.VIEW} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUP}s`}/>
					{
						props.user.loggedInUser.allowedToEditTobas?
							<Button clickHandler={() => props.push(`/solicitors/${TOBA_PATH}s`)} wrapper="btn-wrapper"
									btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
									label={`${CONTENT_STRINGS.VIEW} ${TOBA_SHORT_TEXT}s`}/>
							:
							null
					}
				</div>
			</div>
			<AgentsListFilters
				onQuickSearch={onQuickSearch}
				lawsysFirms={props.lawsysFirms}
				User={props.AgentsList}
				UpdateSolicitorsDisplayedUsers={props.UpdateSolicitorsDisplayedUsers}
				ChangeSolicitorsStatus={props.ChangeSolicitorsStatus}
				DisplayModal={props.DisplayModal}
				FilterByLawsysId={props.FilterByLawsysId}
				ChangeAgentsListSettings={props.changeAgentsListSettings}
				UpdateSolicitors={props.UpdateSolicitors}
				UpdateCheckedSolicitors={props.UpdateCheckedSolicitors}
				solicitorUsersAgentsFilter={props.solicitorUsersAgentsFilter}
				agents={props.AgentsList.allSolicitorUsers}
				SolicitorDisplaySetting={props.SolicitorDisplaySetting}
				receiveGetSolicitors={props.receiveGetSolicitors}
				getSolicitors={props.getSolicitors}
			/>
			<Table
				loading={props.AgentsList.fetching}
				columns={columns}
				data={props.AgentsList.allSolicitorUsers || []}
				striped
				responsive
				selectable
				selected={props.AgentsList.selectedSolicitorUsers}
				onDatumSelect={(checked, rowIndex, row) => props.CheckSolicitor({checked, rowIndex, row})}
				onSelectAll={props.CheckAll}
				selectActions={selectActions}
				onSelectAction={onSelectAction}
				selectedAction={solicitorUsersListSettings.action}
				onSelectedActionApply={props.handleApplyActions}
				accordionItemHeaderFormatter={(row) => `${CONTENT_STRINGS.LAWSYS_ID}: ${row.lawsysId} ${CONTENT_STRINGS.USER_NAME}: ${row.username}`}
				onSortedChange={(columnId) => props.sortAgentsList(columnId)}
				orderBy={solicitorUsersListSettings.sortBy}
				orderAsc={solicitorUsersListSettings.sortOrder === 'asc'}
				page={solicitorUsersListSettings.page}
				pageSize={parseInt(solicitorUsersListSettings.displayAmount)}
				totalRecords={solicitorUsersListSettings.totalRecords}
				totalPages={solicitorUsersListSettings.totalBoxes}
				pageSizeOptions={UI_LIB_TABLE_VIEW_OPTIONS}
				onPageSizeChange={onPageSizeChange}
				goAtPrevious={prevPage}
				goAtNext={nextPage}
				goAtStart={firstPage}
				goAtEnd={lastPage}
				goAtPage={selectPage}
				noResultsMessage={`${CONTENT_STRINGS.NO} ${LEGAL_ADVICE_TEXT.toLowerCase()} ${CONTENT_STRINGS.USER_TO_SHOW}`}
				tableWrapperTestId={"solicitor-users-table"}
			/>
			{
				props.AgentsList.badPatchResponse ?
					<div className="row">
						<FormResponseMessage Message={props.AgentsList.badPatchResponse} CenterWrapper="col-sm-12 mt-15 mb-15" MessageStyle="formResponseMessage-reject" />
					</div>
					:
					null
			}
		</div>
	)
};

export default AgentsList
